<template>
    <div v-can:read-tab="'fiches_resultats'">
        <div class="h2">
            Listing des fiches de résultats
        </div>
        <hr>

        <div class="clearfix" />

        <form
            class="mt-3 py-4 shadow px-3"
            @submit.prevent="search"
        >
            <div class="h4">
                Recherche sur les fiches de résultats
            </div>

            <div class="form-row mt-4">
                <div class="col-2">
                    <base-input
                        v-model="params.dossier"
                        :errors="errors.dossier"
                    >
                        Dossier (CEGID)
                    </base-input>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.equipe"
                        :errors="errors.equipe"
                        :options="optionsEquipes"
                        multiple
                    >
                        Équipe
                    </base-select>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.cabinet"
                        :errors="errors.cabinet"
                        :options="optionsCabinets"
                        multiple
                    >
                        Cabinet
                    </base-select>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.superviseur"
                        :errors="errors.superviseur"
                        :options="optionsSuperviseurs"
                        multiple
                    >
                        Superviseur
                    </base-select>
                </div>

                <div class="col-2">
                    <base-input
                        v-model="params.client"
                        :errors="errors.client"
                    >
                        Client
                    </base-input>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.regime_tva"
                        :errors="errors.regime_tva"
                        :options="optionsRegimesTVA"
                        multiple
                    >
                        Régime TVA
                    </base-select>
                </div>
            </div>

            <div class="form-row">
                <div class="col-2">
                    <base-select
                        v-model="params.cloture"
                        :errors="errors.cloture"
                        :options="optionsClotures"
                        multiple
                        no-search
                    >
                        Clôture
                    </base-select>
                </div>

                <div class="col-2">
                    <base-input
                        v-model="params.exercice"
                        :errors="errors.exercice"
                    >
                        Exercice
                    </base-input>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.lieux_production"
                        :errors="errors.lieux_production"
                        :options="optionsLieuxProductions"
                        multiple
                    >
                        Lieu de production
                    </base-select>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.resultat_statut"
                        :errors="errors.resultat_statut"
                        :options="optionsResultatStatuts"
                        multiple
                    >
                        Statut de la fiche
                    </base-select>
                </div>

                <div class="col-2">
                    <base-input
                        v-model="params.resultat_min"
                        :errors="errors.resultat_min"
                        euros
                    >
                        Résultat min.
                    </base-input>
                </div>

                <div class="col-2">
                    <base-input
                        v-model="params.resultat_max"
                        :errors="errors.resultat_max"
                        euros
                    >
                        Résultat max.
                    </base-input>
                </div>
            </div>

            <div class="form-row">
                <div class="col-2">
                    <base-input
                        v-model="params.total_loyer_min"
                        :errors="errors.total_loyer_min"
                        euros
                    >
                        Total loyer min.
                    </base-input>
                </div>

                <div class="col-2">
                    <base-input
                        v-model="params.total_loyer_max"
                        :errors="errors.total_loyer_max"
                        euros
                    >
                        Total loyer max.
                    </base-input>
                </div>

                <div class="col-2">
                    <base-input
                        v-model="params.ri_cga_min"
                        :errors="errors.ri_cga_min"
                        euros
                    >
                        RI CGA min.
                    </base-input>
                </div>

                <div class="col-2">
                    <base-input
                        v-model="params.ri_cga_max"
                        :errors="errors.ri_cga_max"
                        euros
                    >
                        RI CGA max.
                    </base-input>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.dossier_statut"
                        :errors="errors.dossier_statut"
                        :options="optionsStatuts"
                        multiple
                    >
                        Statut du dossier
                    </base-select>
                </div>

                <div class="col-2">
                    <base-select
                        v-model="params.saisonnier"
                        :errors="errors.saisonnier"
                        :options="optionsOuiNon"
                    >
                        Saisonnier
                    </base-select>
                </div>
            </div>

            <div class="form-row">
                <transition name="fade">
                    <div
                        v-if="params.saisonnier"
                        class="col-2"
                    >
                        <base-input
                            v-model="params.loyer_saisonnier_min"
                            :errors="errors.loyer_saisonnier_min"
                            euros
                        >
                            Loyer saisonnier min.
                        </base-input>
                    </div>
                </transition>

                <transition name="fade">
                    <div
                        v-if="params.saisonnier"
                        class="col-2"
                    >
                        <base-input
                            v-model="params.loyer_saisonnier_max"
                            :errors="errors.loyer_saisonnier_max"
                            euros
                        >
                            Loyer saisonnier max.
                        </base-input>
                    </div>
                </transition>
            </div>

            <div class="form-row">
                <div class="col-2">
                    <base-select
                        v-model="params.plafonnement_cfe"
                        :options="optionsOuiNonEtNonRenseigne"
                    >
                        Plafonnement CFE
                    </base-select>
                </div>
            </div>

            <button
                type="submit"
                class="btn btn-success float-right mt-3 px-4"
            >
                Rechercher
            </button>

            <button
                class="btn btn-info float-right mt-3 px-4 mr-2"
                @click.prevent="reinit"
            >
                Réinitialiser
            </button>
            <span class="clearfix" />
        </form>

        <base-table
            :items="items"
            :meta="meta"
            :params="exParams"
            :loading="loading"
            :head="head"
            name="fiche de résultat"
            no-export
            class="mt-5"
            @orderBy="orderBy"
            @change-page="goToPage"
            @paginate="paginate"
        >
            <div
                slot="extra-buttons"
                class="d-inline-block"
            >
                <button
                    v-can:exec-action="'mails.comptes_annuels'"
                    class="btn btn-secondary btn-sm ml-2"
                    :title="'Ce bouton permet de lister et d\'envoyer massivement les mails de comptes annuels aux clients (sauf les fonciers).'"
                    @click="showModalComptesAnnuelsMails = true"
                >
                    Générer mails comptes annuels
                </button>
            </div>

            <tr
                v-for="fiche of items"
                :key="fiche.id"
            >
                <td>
                    <router-link
                        :to="{name: 'dossier', params: {id: fiche.dossier_id}}"
                        title="Dossier"
                    >
                        {{ fiche.dossier.cegid }}
                    </router-link>
                </td>

                <td>
                    <template v-if="fiche.dossier.client.is_indivision">
                        {{ fiche.dossier.client.type_indivision }} {{ fiche.dossier.client.libelle_indivision }}
                    </template>

                    <template v-else>
                        {{ fiche.dossier.client.nom }} {{ fiche.dossier.client.prenom }}
                    </template>
                </td>

                <td class="text-right">
                    {{ fiche.is_professionnel | yesNo }}
                </td>

                <td class="text-right">
                    {{ fiche.is_resident_francais | yesNo }}
                </td>

                <td class="no-wrap text-right">
                    {{ fiche.total_loyer | euros }}
                </td>

                <td class="text-right">
                    {{ fiche.ri_cga | yesNo }}
                </td>

                <td class="text-right">
                    {{ fiche.dossier.type_missions.map(type => type.nom).join(', ') }}
                </td>

                <td class="no-wrap text-right">
                    {{ fiche.resultat | euros }}
                </td>

                <td class="text-right">
                    {{ fiche.is_rsi | yesNo }}
                </td>

                <td class="text-right">
                    {{ fiche.is_saisonnier | yesNo }}
                </td>

                <td class="no-wrap text-right">
                    {{ fiche.loyer_saisonnier | euros }}
                </td>

                <td class="text-right">
                    {{ fiche.is_gere_par_pro | yesNo }}
                </td>

                <td class="text-right">
                    {{ fiche.dossier.client.is_indivision | yesNo }}
                </td>

                <td class="text-right">
                    {{ fiche.dossier.client.nombre_exploitation }}
                </td>

                <td>
                    <template v-if="fiche.superviseur">
                        {{ fiche.superviseur.nom }} {{ fiche.superviseur.prenom }}
                    </template>
                </td>

                <td class="no-wrap text-right">
                    {{ fiche.base | euros }}
                </td>

                <td>{{ fiche.resultat_statut.nom }}</td>

                <td class="text-center">
                    <router-link
                        :to="{name: 'dossierFicheResultat', params: {id: fiche.dossier_id}}"
                        class="btn btn-primary btn-sm"
                        title="Voir"
                    >
                        <i class="fa fa-glasses" />
                    </router-link>
                </td>
            </tr>
        </base-table>

        <GenererMailsComptesAnnuels
            v-if="showModalComptesAnnuelsMails"
            :additional-params="exParams"
            @close="showModalComptesAnnuelsMails = false"
        />
    </div>
</template>

<script>
    import TableNavigate from "../../mixins/TableNavigate"
    import BaseTable from "../templates/BaseTable"
    import BaseInput from "../templates/BaseInput"
    import BaseSelect from "../templates/BaseSelect"
    import {mapGetters} from "vuex"
    import GenererMailsComptesAnnuels from "../modals/GenererMailsComptesAnnuels"

    export default {
        name: "FichesResultatsList",

        components: {GenererMailsComptesAnnuels, BaseSelect, BaseInput, BaseTable},

        mixins: [TableNavigate],

        url: '/api/fiche-resultats',

        data: function () {
            return {
                params: this.initParams(),
                head: {
                    dossier: 'Dossier',
                    client: 'Client',
                    is_professionnel: 'Professionnel',
                    is_resident_francais: 'Résident français',
                    total_loyer: 'Total loyer',
                    ri_cga: 'RI CGA',
                    typeMissions: 'Type de mission',
                    resultat: 'Résultat',
                    is_rsi: 'RSI',
                    is_saisonnier: 'Saisonnier',
                    loyer_saisonnier: 'Loyer Saisonnier',
                    is_gere_par_pro: 'Géré par pro',
                    is_indivision: 'Indivision',
                    nombre_exploitation: 'Nb exploitations',
                    superviseur: 'Superviseur',
                    base: 'Base CA',
                    resultatStatut: 'Statut',
                },
                optionsOuiNon: [
                    {value: null, label: ''},
                    {value: 1, label: 'Oui'},
                    {value: 0, label: 'Non'},
                ],
                optionsOuiNonEtNonRenseigne: [
                    {value: '', label: 'Tous'},
                    {value: 1, label: 'Oui'},
                    {value: 0, label: 'Non'},
                    {value: 999, label: 'Non renseigné'},
                ],
                optionsResultatTransmission: [
                    {value: '', label: 'Tous'},
                    {value: 'ok', label: 'Ok'},
                    {value: 'rejet', label: 'Rejet'},
                    {value: 'aucun', label: 'Aucun résultat'},
                ],
                showModalComptesAnnuelsMails: false,
            }
        },

        computed: {
            ...mapGetters([
                'optionsEquipes',
                'optionsCabinets',
                'optionsStatuts',
                'optionsSuperviseurs',
                'optionsClotures',
                'optionsResultatStatuts',
                'optionsRegimesTVA',
                'optionsLieuxProductions'
            ]),
        },

        watch: {
            'params.saisonnier': function (value) {
                if (!value) {
                    this.params.loyer_saisonnier_min = null
                    this.params.loyer_saisonnier_max = null
                }
            },

            'params.dossier_statut': function (value) {
                if (!value || !value.includes(this.$store.state.dossiersStatuts.statutTeletransmis)) {
                    this.params.resultat_transmission = null
                }
            }
        },

        created: function () {
            this.$store.dispatch('initResultatStatuts')
        },

        methods: {
            /**
             * Réinitialise les paramètres
             */
            reinit: function () {
                this.params = this.initParams()
            },

            initParams: function () {
                return {
                    paginate: 15,
                    exercice: moment().subtract(5, 'months').year(),
                    type: ['dossier'],
                }
            }
        }
    }
</script>
